import { noop } from 'lodash';

import { NewFilterOption, UseFilterValuesType } from '../types';

const DummyFilterOption: NewFilterOption = {
  value: 'dummy',
  label: 'Dummy',
};

export const useFilterDummyValue: UseFilterValuesType = ({ value }) => {
  return {
    selectedOptions: value.map((item) => DummyFilterOption),
    fetching: false,
    resolvedValue: value.map((item) => item),
  };
};

export const useFilterDummyOptionsQuery = () => {
  return { fetching: false, fetchMore: noop, groups: [] };
};
